import React from "react";

interface IconMinusProps {
  color: string;
}

const IconMinus: React.FC<IconMinusProps> = ({ color }) => {
  return (
    <svg
      width="9"
      height="2"
      viewBox="0 0 9 2"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="minus-icon-title"
    >
      <title id="minus-icon-title">Minus icon</title>
      <path d="M0 1.1875V0H8.3125V1.1875H0Z" fill={color} />
    </svg>
  );
};

export default IconMinus;
